export async function* hsReadProjectFileLines(file: File): AsyncGenerator<string> {
  const reader: ReadableStreamDefaultReader<Uint8Array> = file.stream().getReader();
  const decoder: TextDecoder = new TextDecoder('utf-8', { fatal: true });
  let pending: string = '';
  try {
    while (true) {
      const { value, done } = await reader.read();
      pending += decoder.decode(value, { stream: !done });
      let end: number;
      while ((end = pending.indexOf('\n')) >= 0) {
        yield pending.slice(0, end).replace(/\r$/, '');
        pending = pending.slice(end + 1);
      }
      if (done) {
        if (pending.length > 0) {
          yield pending;
        }
        break;
      }
    }
  } finally {
    reader.releaseLock();
  }
}
